export const sortingType = (user) => {
  if (user?.account_permissions?.export_sorting_zipcode) {
    return 'zipcode'
  }
  else if (user?.account_permissions?.export_sorting_priority) {
    return 'priority'
  }
  else if (user?.account_permissions?.export_sorting_routing || user?.account_permissions?.delivery_app_doc) {
    return 'routing'
  }
  else {
    return 'alphabetical'
  }
}